import * as React from 'react';
import { connect } from 'react-redux';

import ActionButton from 'components/buttons/action-button/ActionButton';

import {
  closeAddEntitiesModal,
  goBackToInitialUploadStep,
  goToSuccessfulUploadStep,
  moveToConfirmation
} from 'modules/create-new-profiles/reducers/actions';

import { CREATE_NEW_PROFILES_MODAL_TEMPLATE_IDENTIFIER } from 'modules/create-new-profiles/constants/common';

import { __t, applyTranslations } from 'utils/language';
import { getSetOfButtonsForCreateNewProfilesModal } from 'modules/create-new-profiles/utils/modal-buttons';

import { CreateNewProfilesModalState } from 'modules/create-new-profiles/types/CreateNewProfiles.type';
import { State } from 'types';

applyTranslations(require('./create-new-profiles-modal-buttons.i18n.json'));

interface StateProps {
  modalState: CreateNewProfilesModalState
}

interface DispatchProps {
  dispatchOnCancel: () => void,
  dispatchOnBack: () => void,
  dispatchOnNext: () => void,
  dispatchOnSave: () => void
}

type Props = StateProps & DispatchProps;

const arePropsEqual = (prevProps: Props, nextProps: Props): boolean => {
  if (
    prevProps.modalState.type === CREATE_NEW_PROFILES_MODAL_TEMPLATE_IDENTIFIER
    && nextProps.modalState.type === CREATE_NEW_PROFILES_MODAL_TEMPLATE_IDENTIFIER
  ) {
    return prevProps.modalState.data?.type === nextProps.modalState.data?.type;
  }

  return prevProps.modalState.type === nextProps.modalState.type;
};

const CreateNewProfilesModalButtons = React.memo(({
  modalState,
  dispatchOnBack,
  dispatchOnCancel,
  dispatchOnNext,
  dispatchOnSave
}: Props): JSX.Element => {
  const buttons = getSetOfButtonsForCreateNewProfilesModal(
    modalState,
    {
      back: {
        text: __t('create_new_profiles_modal_buttons.back'),
        action: dispatchOnBack
      },
      cancel: {
        text: __t('create_new_profiles_modal_buttons.cancel'),
        action: dispatchOnCancel
      },
      next: {
        text: __t('create_new_profiles_modal_buttons.next'),
        action: dispatchOnNext
      },
      save: {
        text: __t('create_new_profiles_modal_buttons.save'),
        action: dispatchOnSave
      }
    }
  );

  return (
    <React.Fragment>
      {buttons.map(button => (
        <ActionButton
          key={button.type}
          color={button.type}
          onClick={button.action}
        >
          {button.text}
        </ActionButton>
      ))}
    </React.Fragment>
  );
}, arePropsEqual);

const mapStateToProps = ({ createNewProfiles }: State): StateProps => ({
  modalState: createNewProfiles.createEntitiesModal
});

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchOnBack: () => dispatch(goBackToInitialUploadStep()),
  dispatchOnCancel: () => dispatch(closeAddEntitiesModal()),
  dispatchOnNext: () => dispatch(goToSuccessfulUploadStep()),
  dispatchOnSave: () => dispatch(moveToConfirmation())
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateNewProfilesModalButtons);
